
































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import StBadge from "@/components/basic/StBadge.vue";

@Component({
  components: {StBadge},
})
export default class StEditDiv extends Vue {
  @Prop() editTooltip!: string;
  @Prop() value!: string;
  @Prop() editBtnFlexClass!: string;
  @Prop() textFlexClass!: string;
  @Prop() placeholder!: string;
  @Prop() hideEditOnEmpty!: boolean;
  @Prop() editDisabled!: boolean;
  editMode: boolean = false;

  initialValue: string = '';

  get textFlexClassVar(){
    return this.textFlexClass ?? 'items-start';
  }

  get editBtnFlexClassVar(){
    return this.editBtnFlexClass ?? 'items-center';
  }

  setEditModeTrue(){
    this.editMode = true;
    this.$emit('editMode')
  }

  @Watch('editMode')
  editModeChanged() {
    if (this.editMode) {
      this.initialValue = this.value;
    }
  }

  @Emit('input')
  reset() {
    this.editMode = false;
    return this.initialValue;
  }
}
